import React from 'react';
import Modal from '../../modal';
import "./link.css";

class Link extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
        };
    }

    openModal = () => {
        this.setState({ modalOpen: true });
    };

    closeModal = () => {
        this.setState({ modalOpen: false });
    };

    render() {
        const { text, modalContent, link } = this.props;
        const { modalOpen } = this.state;

        const linkContent = <p className="link-text">{text}</p>;

        // If link prop is provided, render as anchor tag
        if (link) {
            return (
                <a 
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link link-external"
                    style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
                >
                    {linkContent}
                </a>
            );
        }

        // Otherwise, render as clickable div for modal or non-interactive
        return (
            <>
                <div 
                    className="link" 
                    onClick={modalContent ? this.openModal : undefined}
                    style={{ cursor: modalContent ? 'pointer' : 'default' }}
                >
                    {linkContent}
                </div>
                {modalContent && (
                    <Modal isOpen={modalOpen} onClose={this.closeModal}>
                        {modalContent}
                    </Modal>
                )}
            </>
        );
    }
}

export default Link;